import { api } from "@/api";
import { AxiosResponse } from "axios";
import { PayloadTransmissionAccess } from "../types";
class API {
  static postTransmission(payload: any): Promise<AxiosResponse> {
    return api.post(`/transmissions/zoom`, payload);
  }
  static putTransmission(payload: any): Promise<AxiosResponse> {
    return api.put(`/transmissions/zoom/${payload.id}`, payload.params);
  }
  static getTransmissionZoom(id: string): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/meeting/external/${id}`);
  }
  static getCurrentTransmission(): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/meeting/current`);
  }
  static getCurrentTransmissionEdit(id: string): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/${id}`);
  }
  static getCurrentTransmissionById(id: string): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/${id}`);
  }
  static getNextTransmissionList(): Promise<AxiosResponse> {
    return api.get(`/transmissions/zoom/meeting/list`);
  }
  static postCreateAccess(
    payload: PayloadTransmissionAccess
  ): Promise<AxiosResponse> {
    return api.post("/transmissions/zoom/meeting/create-access", payload);
  }
}

export default API;
